import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [currentOrg, setCurrentOrg] = useState(null);
  const [globalLoading, setGlobalLoading] = useState(false);

  const toggleSidebar = () => setSidebarOpen(prev => !prev);
  
  const addNotification = (message, type = 'info') => {
    const id = Date.now();
    setNotifications(prev => [...prev, { id, message, type }]);
    setTimeout(() => {
      removeNotification(id);
    }, 5000);
  };

  const removeNotification = (id) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  };

  const value = {
    sidebarOpen,
    toggleSidebar,
    setSidebarOpen,
    notifications,
    addNotification,
    removeNotification,
    currentOrg,
    setCurrentOrg,
    globalLoading,
    setGlobalLoading
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

AppProvider.propTypes = {
  children: PropTypes.node.isRequired
};
